// Icon lookup for condition types. Maps each node type to the marker icon
// rendered by Pluma's ConditionViewerItem.
// Matches ~/code/ui condition-editor-v2 node views.

import type { IconName } from '@customerio/pluma-icons';
import type { ConditionNode, MessageChannel } from '../types';

const NODE_TYPE_ICONS: Record<ConditionNode['type'], IconName> = {
  group: 'filter',
  attribute: 'person',
  event: 'trigger-event',
  segment: 'segment',
  device: 'mobile',
  pageview: 'link',
  screenview: 'modal-bottom',
  form: 'form',
  message: 'email',
  inbound: 'sms',
  opt_out: 'sms',
  relationship: 'connections',
  unknown: 'error',
};

const CHANNEL_ICONS: Record<MessageChannel, IconName> = {
  email: 'email',
  sms: 'sms',
  push: 'mobile',
  in_app: 'in-app',
  slack: 'slack',
  webhook: 'webhook',
  whatsapp: 'sms',
  line: 'sms',
  message: 'email',
};

export function getIconForNode(node: ConditionNode): IconName {
  if (node.type === 'message') {
    return CHANNEL_ICONS[node.channel] ?? 'email';
  }
  return NODE_TYPE_ICONS[node.type] ?? 'error';
}
